module.exports = __webpack_public_path__ + "img/blog.f87d3158.jpg";